/*
 * @Description: index
 * @Author: yingbin
 * @Date: 2019-08-23 15:26:40
 * @LastEditTime: 2019-08-26 15:26:10
 * @LastEditors: yingbin
 */
import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})
export default store